import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import LocalisedMessage from 'components/Common/LocalisedMessage';
import NotFoundError from 'components/Errors/NotFoundError';

const FooterLinkPage = ({ intl, match }) => {
  const messageId = () => {
    let id = `footer.${ match.params.pageType }`;
    if (match.params.pageType === 'eula') {
      id = 'eula';
    }
    return id;
  };

  const preamble = () => {
    const preambleId = `${ messageId() }.preamble`;
    if (intl && intl.messages && !!intl.messages[preambleId]) {
      return <div className="row mb-5"><LocalisedMessage id={ preambleId } /></div>;
    }
    return null;
  };

  const contentExists = () => {
    const msgId = messageId();
    return intl
      && intl.formatMessage({ id: msgId }) !== msgId
      && !!intl.formatMessage({ id: msgId });
  };

  return <section className="container footer-page mt-5">
    { preamble() }
    { contentExists() && <div className="row">
      <div className="col-xs-12">
        <LocalisedMessage id={ messageId() } />
      </div>
    </div> }
    { !contentExists() && <NotFoundError /> }
  </section>;
};

FooterLinkPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      pageType: PropTypes.string
    })
  }).isRequired,
  intl: PropTypes.shape({
    messages: PropTypes.any,
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

export default (injectIntl(FooterLinkPage));
